/**
 * This function calculates the spread distance (in meters) for map markers based on the current zoom level.
 * As the map zooms out, the spread distance increases.
 * As the map zooms in, the spread distance decreases for accuracy.
 * This is used to visually separate markers that are overlapping.
 */
const getSpreadDistance = (zoom: number) => {
  if (zoom >= 18) return 3; // Very zoomed in
  if (zoom >= 17) return 8;
  if (zoom >= 16) return 15;
  if (zoom >= 15) return 50;
  if (zoom >= 14) return 50;
  if (zoom >= 13) return 150;
  if (zoom >= 12) return 200;
  if (zoom >= 11) return 500;
  if (zoom >= 10) return 1000;
  if (zoom >= 9) return 2800;
  if (zoom >= 8) return 3400;
  return 7000; // Very zoomed out
};

export default getSpreadDistance;
